import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { OMS_COLORS, sectionVariants } from '../../dashboard/omsDashTheme';
import { ADMIN_EYEBROW_CLASS } from '../adminTheme';
import type { AdminInsight } from '../utils/adminMetrics';

interface Props {
  /** The computed one-liner (growth + adoption + biggest anomaly). */
  sentence: string;
  topInsight: AdminInsight | null;
  onOpenInsight: (insight: AdminInsight) => void;
  userName: string;
  loading: boolean;
}

/**
 * Admin brief — one humane computed sentence naming at most one anomaly,
 * with a deep-link into the view that proves it.
 */
export default function AdminBrief({ sentence, topInsight, onOpenInsight, userName, loading }: Props) {
  const hour = new Date().getHours();
  const greeting =
    hour >= 5 && hour < 12 ? 'Good morning' : hour >= 12 && hour < 17 ? 'Good afternoon' : 'Good evening';
  return (
    <motion.section
      variants={sectionVariants}
      initial="hidden"
      animate="visible"
      custom={0}
      aria-label="Admin brief"
      className="px-1"
    >
      <p className={ADMIN_EYEBROW_CLASS}>Platform analytics · Admin</p>
      <h1 className="mt-1 text-[24px] font-extrabold leading-tight tracking-tight lg:text-[27px]" style={{ color: OMS_COLORS.tealDark }}>
        {greeting}{userName ? `, ${userName}` : ''}
      </h1>
      <span
        aria-hidden
        className="mt-1.5 block h-[2px] w-11 rounded-full"
        style={{ background: 'linear-gradient(to right, #14606B 0%, rgba(20,96,107,0) 100%)' }}
      />
      <p className="mt-2 max-w-3xl text-[13px] italic leading-snug" style={{ color: '#5A6275' }}>
        “{loading && !sentence ? 'Reading the platform pulse…' : sentence}”
        {topInsight && (
          <button
            type="button"
            onClick={() => onOpenInsight(topInsight)}
            className="ml-2 inline-flex items-center gap-0.5 align-middle text-[10px] font-extrabold uppercase not-italic tracking-[0.1em] transition hover:underline"
            style={{ color: '#14606B' }}
          >
            See it <ArrowUpRight className="h-3 w-3" />
          </button>
        )}
      </p>
    </motion.section>
  );
}
